<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

const props = defineProps({ type: { type: String, required: true } })
const { t } = useI18n()

const TONE = {
  deposit: 'info',
  final_payment: 'ok',
  partial_payment: 'info',
  extra_charge: 'warn',
  refund: 'danger',
  write_off: 'muted',
}

const label = computed(() =>
  props.type === 'write_off'
    ? t('rental.show.writtenOffLabel')
    : t(`rental.show.paymentModal.types.${props.type}`),
)
const tone = computed(() => TONE[props.type] || 'muted')
const strike = computed(() => props.type === 'write_off')
</script>

<template>
  <UiStatusPill
    :tone="tone"
    variant="soft"
    :label="label"
    :strike="strike"
  />
</template>
